// MIDI note <-> frequency helpers. Pure math, unit-tested (A4 = 69 = 440 Hz).

export const A4_MIDI = 69;
export const A4_FREQ = 440;

/** Convert a (possibly fractional) MIDI note number to frequency in Hz. */
export function midiToFreq(midi: number, a4 = A4_FREQ): number {
  return a4 * Math.pow(2, (midi - A4_MIDI) / 12);
}

/** Inverse of `midiToFreq` — returns a (possibly fractional) MIDI note number. */
export function freqToMidi(freq: number, a4 = A4_FREQ): number {
  return A4_MIDI + 12 * Math.log2(freq / a4);
}

const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

/** Human-readable name for a MIDI note, e.g. 60 -> "C4", 69 -> "A4". */
export function noteName(midi: number): string {
  const n = Math.round(midi);
  const name = NOTE_NAMES[((n % 12) + 12) % 12]!;
  const octave = Math.floor(n / 12) - 1;
  return `${name}${octave}`;
}

/** Apply a detune in cents to a frequency. */
export function applyCents(freq: number, cents: number): number {
  return freq * Math.pow(2, cents / 1200);
}
